import { ref } from 'vue'

export interface MobileRenameRequest {
  title: string
  currentName: string
  submit: (name: string) => Promise<void>
}

export const MOBILE_RENAME_REQUEST_EVENT = 'mobile-rename-request'
export const isMobileRenameSheetOpen = ref(false)

export const openMobileRenameSheet = (request: MobileRenameRequest): void => {
  window.dispatchEvent(
    new CustomEvent<MobileRenameRequest>(MOBILE_RENAME_REQUEST_EVENT, { detail: request }),
  )
}
